import styled from 'styled-components';
import { colors } from '@/globalStyles';
import hexToRgbA from '@/helpers/hexToRgba';

export const ContextMenuStyled = styled.div`
  min-width: 340px;
  padding: 0px 5px;
`;

export const MaterialInfoBlockStyled = styled.div`
  padding: 15px 20px 10px;
`;

export const MaterialInfoHeaderStyled = styled.div`
  text-transform: uppercase;
  margin-bottom: 15px;
`;

export const MaterialInfoBodyStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 20px;
  font-family: SourceSansPro;
  font-weight: 400;
`;

export const OptionsBlockStyled = styled.div`
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  padding: 10px 0px;
`;

export const OptionStyled = styled.div`
  border-radius: 4px;
  padding: 7px 20px;
  cursor: pointer;

  &:hover {
    color: ${colors.primary};
    background: ${hexToRgbA(colors.primary, 0.05)};
  }
`;

export const FooterStyled = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  grid-auto-flow: row;
  gap: 7px;
  padding: 20px;
  border-radius: 0px 0px 6px 6px;
  color: #636363;
`;
